import { Provider, Signal } from "@angular/core";
import {
    ATOM_DIALOG_CLOSE_ARIA_LABEL,
    ATOM_DIALOG_CTA_ARIA_LABEL,
} from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "atom_dialog";

/**
 * Localizes the default close and CTA (back) icon-buttons of
 * `atom-dialog-header`.
 *
 * Token is a `Signal<string>` and stays in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}.
 */
export const provideAtomDialogLabels = (): Provider[] => [
    {
        provide: ATOM_DIALOG_CLOSE_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.close_aria_label`),
    },
    {
        provide: ATOM_DIALOG_CTA_ARIA_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.cta_aria_label`),
    },
];
